import { FormTextArea, FormTextInput } from "components/form-fields";
import { useValidation } from "hooks/useValidation";
import React, { useEffect } from "react";

export function ManualEntryTemplateDetails({ template, onValidChange, saving, loading, onTemplateUpdate, readOnly=false }) {
    
    const [isValid, errors, validate] = useValidation(false);
            
    useEffect(function () {
        onValidChange(isValid);
    }, [isValid]);
    
    useEffect(() => {
        const rules = [{ fieldName: "name", required: true }];
        const externalRules = [];
        validate(rules, template, externalRules);
    }, [template?.name]);

    function onDescriptionUpdate(event) {
        onTemplateUpdate({ description: event.target.value })
    }

    function onNameUpdate(event) {
        onTemplateUpdate({ name: event.target.value })
    }

    return (
        <>
            <FormTextInput
                id="settings-template-name"
                disabled={saving || readOnly}
                loading={loading}
                headingText="Template name"
                onChange={readOnly ? null : onNameUpdate}
                value={template.name}
                dangerHelperText={errors["name"]}
                wide
            />

            <FormTextArea
                id="settings-template-description"
                maxLength={250}
                showCounter
                disabled={saving || readOnly}
                loading={loading}
                onChange={onDescriptionUpdate}
                headingText="Template description"
                value={template.description ?? ""}
                readOnly={readOnly}
            />
        </>
    );
}